export const CONSENT_COOKIE_NAME = 'verdea-consent';
export const CONSENT_VERSION = '1.1';
export const CONSENT_EXPIRY_DAYS = 183; // ~6 months
export const CONSENT_STORAGE_KEY = 'verdea-cookie-consent';

// Google Analytics + Hotjar
export const ANALYTICS_COOKIE_PATTERNS: string[] = [
  '_ga',
  '_gid',
  '_gat',
  '_hjSession',
  '_hjSessionUser',
  '_hjAbsoluteSessionInProgress',
  '_hjFirstSeen',
  '_hjIncludedInPageviewSample',
  '_hjIncludedInSessionSample',
];

// LinkedIn Insight Tag
export const MARKETING_COOKIE_PATTERNS: string[] = [
  'bcookie',
  'li_gc',
  'lidc',
  'li_sugr',
  'UserMatchHistory',
  'AnalyticsSyncHistory',
  'ln_or',
];
